import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ENTITIES, ORDER, QuerbuilderPayloadColumns } from 'src/models/QuerybuilderModel';
import Datagrid from 'src/components/Datagrid/Datagrid';
import { useEffect } from 'react';
import {
  getEntitiesAction, resetQueryBuilderResult,
  setColumns,
  setFilters,
  setOrders,
  setQueryBuilderResult,
} from 'src/redux/actions/querybuilderActions';
import DEFAULT_COLUMNS from 'src/constants/columns';
import { resetSelections } from 'src/redux/actions/selectionActions';
import { t } from 'src/lib/language';
import { setSelectedPresets } from 'src/redux/actions/selectedPresetActions';
import { PRESET_TYPES } from 'src/models/PresetModel';
import { getFundraisingAction } from 'src/redux/actions/fundraisingAction';
import DatagridToolbar from 'src/components/DatagridToolbar/DatagridToolbar';
import DatagridSearch from 'src/components/DatagridSearch/DatagridSearch';
import TransactionForFundraisingHeader
  from 'src/components/DatagridToolbar/entities/TransactionForFundraisingHeader';

const TransactionsForFundraisingDatagrid = () => {
  const dispatch = useAppDispatch();

  const getfundraisingId = () => {
    const pathSegments = window.location.pathname.split('/');
    return pathSegments[pathSegments.length - 1];
  };

  const lang = useSelector((state: Store) => state.language.language);
  const fundraising = useSelector((state: Store) => state.fundraisings[getfundraisingId()]);

  const { defaultLayout, defaultLayoutId } = useSelector(
    (state: Store) => {
      const result = {
        defaultLayout: null,
        defaultLayoutId: 0,
      };
      const entity = ENTITIES.fundraisingTransactions;
      const type = PRESET_TYPES.layout;
      if (!state.presets[entity]) return result;
      if (!state.presets[entity][type]) return result;
      const defaultPreset = state.presets[entity][type].find((preset) => preset.is_default);
      if (defaultPreset) {
        return {
          defaultLayout: defaultPreset.filter,
          defaultLayoutId: defaultPreset.id,
        };
      }
      return result;
    },
  );

  useEffect(() => {
    dispatch(getFundraisingAction(getfundraisingId()));
    dispatch(setSelectedPresets({
      entity: ENTITIES.fundraisingTransactions,
      type: PRESET_TYPES.layout,
      id: defaultLayoutId,
    }));
    dispatch(setColumns({
      entity: ENTITIES.fundraisingTransactions,
      columns: defaultLayout || DEFAULT_COLUMNS[ENTITIES.fundraisingTransactions],
    } as QuerbuilderPayloadColumns));
    dispatch(resetQueryBuilderResult({ entity: ENTITIES.fundraisingTransactions }));
    dispatch(setOrders({
      entity: ENTITIES.fundraisingTransactions,
      order: [['event_transactions.id', ORDER.desc]],
    }));
    dispatch(setFilters({
      entity: ENTITIES.fundraisingTransactions,
      filters: {
        and: [['event_transactions.event_id', '=', getfundraisingId()]],
      },
    }));
    dispatch(resetSelections({ entity: ENTITIES.fundraisingTransactions }));
    dispatch(setQueryBuilderResult({
      entity: ENTITIES.fundraisingTransactions,
      result: {
        count: 0,
        list: [],
      },
    }));
    dispatch(getEntitiesAction(ENTITIES.fundraisingTransactions));
  }, []);

  const getTitle = () => {
    if (!fundraising) return '';
    if (!fundraising.fundraisingInfo?.name) return `#${fundraising.fundraisingInfo?.id}`;
    return `${fundraising.fundraisingInfo?.name} (#${fundraising.fundraisingInfo?.id})`;
  };

  useEffect(() => {
    if (!fundraising) return;
    document.title = `${t(lang, 'menus.transactions_for_fundraising')}: ${getTitle()}`;
  }, [fundraising]);

  return (
    <>
      <TransactionForFundraisingHeader title={getTitle()} />
      <DatagridSearch entity={ENTITIES.fundraisingTransactions} hideAdvancedSearch />
      <DatagridToolbar entity={ENTITIES.fundraisingTransactions} />
      <Datagrid entity={ENTITIES.fundraisingTransactions} singleSelection dontReloadEntities />
    </>
  );
};

export default TransactionsForFundraisingDatagrid;
